import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';

//lista los jugadores que el club tuvo en campeonatos anteriores para agregarlos al equipo sin registrarlos de nuevo
@Component({
    selector: 'app-historial-jugadores',
    templateUrl: './historial-jugadores.component.html',
    styleUrls: ['./historial-jugadores.component.css'],
    standalone: false
})
export class HistorialJugadoresComponent extends BaseComponent implements OnInit {

  equipo:any;
  id_cliente:any;
  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();
  historial:any[]=[];
  texto_busqueda:string="";
  solo_misma_categoria:boolean=true;
  cargando:boolean=true;

  constructor(
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public campeonatosService:CampeonatosService) {
      super(persistenciaService,modalService,generalService,usuarioService);
  }

  async ngOnInit(): Promise<void> {
    let res:any=await this.campeonatosService.obtenerHistorialJugadoresCliente(this.id_cliente,this.equipo.id).toPromise();
    this.cargando=false;
    if(res.tiene_error){
      this.toastr.error(res.mensaje);
      return;
    }
    this.historial=res;
    //si el club nunca jugo esta categoria, se muestra todo su historial
    if(!this.historial.some(item => item.misma_categoria)){
      this.solo_misma_categoria=false;
    }
  }

  obtenerHistorialFiltrado(){
    let texto=(this.texto_busqueda || "").trim().toUpperCase();
    return this.historial.filter(item =>
      (!this.solo_misma_categoria || item.misma_categoria) &&
      (!texto || (item.jugador.persona.nombre_completo || "").toUpperCase().indexOf(texto)>-1 || (item.jugador.persona.ci || "").toString().indexOf(texto)>-1)
    );
  }

  obtenerSeleccionados(){
    return this.historial.filter(item => item.seleccionado);
  }

  //marca o desmarca todos los visibles que se pueden agregar
  seleccionarTodos(seleccionado){
    this.obtenerHistorialFiltrado().filter(item => !item.ocupado_en).forEach(item => item.seleccionado=seleccionado);
  }

  todosSeleccionados(){
    let disponibles=this.obtenerHistorialFiltrado().filter(item => !item.ocupado_en);
    return disponibles.length>0 && disponibles.every(item => item.seleccionado);
  }

  agregarSeleccionados(){
    let seleccionados=this.obtenerSeleccionados();
    if(seleccionados.length==0){
      this.toastr.error("¡Debe seleccionar al menos un jugador!");
      return;
    }
    this.blockUI.start();
    this.campeonatosService.vincularJugadoresEquipo({
      id_cliente:this.id_cliente,
      id_equipo:this.equipo.id,
      ids_jugadores:seleccionados.map(item => item.jugador.id)
    }).subscribe((res:any) => {
      this.blockUI.stop();
      if(res.tiene_error){
        this.toastr.error(res.mensaje);
        return;
      }
      if(res.agregados.length>0){
        this.toastr.success(res.mensaje);
      }
      res.rechazados.forEach(rechazado => this.toastr.warning((rechazado.nombre || "Jugador")+": "+rechazado.motivo));
      this.alTerminar.emit(res);
    });
  }

  cerrarComponente(){
    this.alTerminar.emit();
  }

}
